import Axios from "./axios";

const resource = "billing-informations";

export default {
  create(data) {
		return Axios.post(`${resource}`, data);
	}
}